module.exports = __webpack_public_path__ + "img/Sports & Fitness.4513eb7d.png";